export const STATUS = Object.freeze({
    hidden: 0,
    visible: 1,
    open: 2,
    owned: 3
});

/**
 * Function to determine a dot's visibility based upon the presence of the portfolioLongName and uuid attributes.
 * @param {Object} dot
 * @returns {number} - STATUS enum value
 */
export function getStatus(dot) {
    let status;
    const portfolioLongName = dot?.portfolioLongName;
    if (portfolioLongName) {
        if (portfolioLongName === 'Hidden Portfolio') {
            status = STATUS.hidden;
        } else if (dot?.uuid) {
            status = STATUS.open;
        } else {
            status = STATUS.visible;
        }
    }
    return status;
}
